import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from 'react';
import ButtonComponent from './ButtonComponent';
import ShareFileModal from './ShareFileModal';
import { DataContext } from '../player/DataContext';
var ShareComp = function (props) {
    var btnData = props.btnData, item = props.item, isParentRelative = props.isParentRelative, clickHandler = props.clickHandler, direction = props.direction, btnType = props.btnType;
    var _a = useContext(DataContext), showShareModal = _a.showShareModal, setShowShareModal = _a.setShowShareModal;
    var modalRef = useRef(null);
    var onClickHandler = function () {
        clickHandler(btnData[item].id, btnData[item].type, undefined);
    };
    // ===== CLOSE ON OUTSIDE CLICK =====
    useEffect(function () {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClickHandler(); // fire callback
            }
        }
        if (showShareModal)
            document.addEventListener('mousedown', handleClickOutside);
        return function () { return document.removeEventListener('mousedown', handleClickOutside); };
    }, [showShareModal]);
    return (_jsxs("div", { ref: modalRef, style: { position: 'relative', zIndex: showShareModal ? 999 : undefined }, children: [_jsx(ButtonComponent, { imgSrc: btnData[item].imgSrc, defaultCSS: btnType['style'].defaultCSS, normalCSS: btnType['style'].normalCSS, ariaLabel: btnData[item].ariaLabel, title: btnData[item].title, showToolTip: true, direction: direction, isParentRelative: isParentRelative, clickHandler: function (e) {
                    clickHandler(btnData[item].id, btnData[item].type, e);
                }, isActive: showShareModal, clickActive: btnData[item].activeState }), showShareModal && (_jsx(ShareFileModal, { onClose: function () {
                    onClickHandler();
                } }))] }));
};
export default ShareComp;
